import React from 'react';
import PublicLegalContentPage from '../../components/public/PublicLegalContentPage';

const PartnershipsPage = () => (
  <PublicLegalContentPage
    slug="partnerships"
    seoTitle="Partnerships | Pleerity Enterprise Ltd"
    seoDescription="Collaborate with Pleerity to deliver secure automation, compliance, and digital transformation solutions."
    canonicalUrl="/partnerships"
  />
);

export default PartnershipsPage;
